/** Match words across all supplied row details, including numbers and formatted values. */
export function matchesTableSearch(query: string, details: unknown): boolean {
  const values = (value: unknown): string => {
    if (value === null || value === undefined) return "";
    if (Array.isArray(value)) return value.map(values).join(" ");
    if (typeof value === "object") return Object.values(value).map(values).join(" ");
    return String(value);
  };
  const text = values(details).toLocaleLowerCase();
  return query.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean).every((word) => text.includes(word));
}
